/**
 * Re-exported from the canonical library @zag/core/models.
 * This file exists so that @zag/locations/api consumers can import
 * location schemas from the domain-specific @zag/locations/models path.
 */
export {
  locationQuerySchema,
  type LocationQuery,
  createLocationSchema,
  type CreateLocation,
  updateLocationSchema,
  type UpdateLocation,
  type LocationResponse,
} from '@zag/core/models';
